/** Maximum email length (AWS Cognito & RFC 5321) */
export const MAX_EMAIL_LENGTH = 256;
/** Maximum password length (AWS Cognito) */
export const MAX_PASSWORD_LENGTH = 128;
/** Maximum full name length */
export const MAX_FULL_NAME_LENGTH = 100;
/** Maximum confirmation/reset code length (Cognito sends 6-digit codes) */
export const MAX_CONFIRMATION_CODE_LENGTH = 6;
